/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import { IAccountingBankAccount } from 'app/shared/model/accounting-bank-account.model';
import { IClinicalDictionary } from 'app/shared/model/clinical-dictionary.model';
import { IAccountingCurrency } from 'app/shared/model/accounting-currency.model';
import { IAccountingTax } from 'app/shared/model/accounting-tax.model';
import { IAccountingCollectionLedger } from 'app/shared/model/accounting-collection-ledger.model';
import { IAccountingReconciliation } from 'app/shared/model/accounting-reconciliation.model';
import { AddedByType } from 'app/shared/model/enumerations/added-by-type.model';

export interface IAccountingTransaction {
  id?: string;
  type?: string;
  transactionNumber?: string | null;
  paidAt?: number;
  amount?: number;
  currencyRate?: number;
  description?: string | null;
  reconciled?: boolean;
  active?: boolean;
  cursor?: number;
  lastUpdated?: number;
  microSec?: number;
  timestampEntry?: number;
  resultingBalance?: number;
  createdById?: string | null;
  createdByType?: keyof typeof AddedByType | null;
  pharmacySupplierId?: string | null;
  account?: IAccountingBankAccount | null;
  category?: IClinicalDictionary | null;
  paymentMethod?: IClinicalDictionary | null;
  currency?: IAccountingCurrency | null;
  taxes?: IAccountingTax[] | null;
  transactions?: IAccountingCollectionLedger[] | null;
  parent?: IAccountingTransaction | null;
  reconciliations?: IAccountingReconciliation[] | null;
}

export const defaultValue: Readonly<IAccountingTransaction> = {
  reconciled: false,
  active: false,
};
